<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  // mounted() {
  //   if (this._isMobile()) {
  //     window.location.href = "http://m.pearlriver.sg/#/index";
  //   } else {
  //     //window.location.href = "http://www.pearlriver.sg/#/index";
  //     window.location.href = "http://localhost:8080/#/index";
  //   }
  // },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  watch: {
    "$route.path": {
      handler(to, from) {
        window.location.clear;
        window.location.reload();
      },
      deep: true,
    },
  },
};
</script>

<style lang='less'>
@import "less/common.less";
// #app {
//   font-family: "Noto Sans SC";
//   font-style: normal;
//   font-weight: 400;
//   color: #727272;
// }
.spinner3 {
  width: 40px;
  height: 40px;
  position: relative;
  -webkit-animation: rotate 2s infinite linear;
  animation: rotate 2s infinite linear;
}
.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #fff;
  border-radius: 100%;
  -webkit-animation: bounce 2s infinite ease-in-out;
  animation: bounce 2s infinite ease-in-out;
}
.dot2 {
  top: auto;
  bottom: 0px;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
</style>
